<template>
    <div style="min-height: 100vh">
        <div class="table__tb--tool">
            <div class="row__tb header__tb">
                <div class="cell__tb">大項目</div>
                <div class="cell__tb">中項目</div>
                <div class="cell__tb">小項目</div>
                <div class="cell__tb">詳細</div>
                <div class="cell__tb">パートナー</div>
                <div class="cell__tb">ツール</div>
            </div>
            <!-- Vòng lặp qua các large items -->
            <template v-for="largeItem in listToolPartner">
                <!-- Trường hợp chỉ có largeItem (không có medium items) -->
                <div
                    v-if="!largeItem.medium_items || largeItem.medium_items.length === 0"
                    class="row__tb"
                    :key="'large-only-' + largeItem.large_item.id"
                    :class="{ 'end--scoppe__tool': largeItem.end_line }"
                >
                    <div class="cell__tb">
                        <div style="min-width: 80px">{{ largeItem.large_item.value }}</div>
                    </div>
                    <div class="cell__tb">
                        <div style="min-width: 80px"></div>
                    </div>
                    <div class="cell__tb">
                        <div style="min-width: 80px"></div>
                    </div>
                    <div class="cell__tb">
                        <div style="min-width: 80px"></div>
                    </div>
                    <div class="cell__tb">
                        <div style="max-width: 320px">{{ largeItem.partner?.name || '' }}</div>
                    </div>
                    <div class="cell__tb">
                        <div style="max-width: 320px">{{ largeItem.tool?.tool || '' }}</div>
                    </div>
                </div>
                <!-- Vòng lặp qua các medium items -->
                <template v-for="mediumItem in largeItem.medium_items">
                    <!-- Trường hợp medium item có small items -->
                    <template v-if="mediumItem.small_items && mediumItem.small_items.length > 0">
                        <!-- Vòng lặp qua các small items -->
                        <template v-for="smallItem in mediumItem.small_items">
                            <!-- Trường hợp small item có detail items -->
                            <template v-if="smallItem.detail_items && smallItem.detail_items.length > 0">
                                <!-- Vòng lặp qua các detail items -->
                                <div
                                    v-for="detailItem in smallItem.detail_items"
                                    :key="'detail-' + detailItem.detail_item.id"
                                    class="row__tb"
                                    :class="{ 'end--scoppe__tool': detailItem.end_line }"
                                >
                                    <div class="cell__tb">
                                        <div style="min-width: 80px">{{ largeItem.large_item.value }}</div>
                                    </div>
                                    <div class="cell__tb">
                                        <div style="min-width: 80px">{{ mediumItem.medium_item.value }}</div>
                                    </div>
                                    <div class="cell__tb">
                                        <div style="min-width: 80px">{{ smallItem.small_item.value }}</div>
                                    </div>
                                    <div class="cell__tb">
                                        <div style="min-width: 80px">{{ detailItem.detail_item.value }}</div>
                                    </div>
                                    <div class="cell__tb">
                                        <div style="max-width: 320px">{{ detailItem.partner?.name || '' }}</div>
                                    </div>
                                    <div class="cell__tb">
                                        <div style="max-width: 320px">{{ detailItem.tool?.tool || '' }}</div>
                                    </div>
                                </div>
                            </template>
                            <!-- Trường hợp small item không có detail items -->
                            <div
                                v-else
                                class="row__tb"
                                :key="'small-only-' + smallItem.small_item.id"
                                :class="{ 'end--scoppe__tool': smallItem.end_line }"
                            >
                                <div class="cell__tb">
                                    <div style="min-width: 80px">{{ largeItem.large_item.value }}</div>
                                </div>
                                <div class="cell__tb">
                                    <div style="min-width: 80px">{{ mediumItem.medium_item.value }}</div>
                                </div>
                                <div class="cell__tb">
                                    <div style="min-width: 80px">{{ smallItem.small_item.value }}</div>
                                </div>
                                <div class="cell__tb">
                                    <div style="min-width: 80px"></div>
                                </div>
                                <div class="cell__tb">
                                    <div style="max-width: 320px">{{ smallItem.partner?.name || '' }}</div>
                                </div>
                                <div class="cell__tb">
                                    <div style="max-width: 320px">{{ smallItem.tool?.tool || '' }}</div>
                                </div>
                            </div>
                        </template>
                    </template>
                    <!-- Trường hợp medium item không có small items -->
                    <div
                        v-else
                        class="row__tb"
                        :key="'medium-only-' + mediumItem.medium_item.id"
                        :class="{ 'end--scoppe__tool': mediumItem.end_line }"
                    >
                        <div class="cell__tb">
                            <div style="min-width: 80px">{{ largeItem.large_item.value }}</div>
                        </div>
                        <div class="cell__tb">
                            <div style="min-width: 80px">{{ mediumItem.medium_item.value }}</div>
                        </div>
                        <div class="cell__tb">
                            <div style="min-width: 80px"></div>
                        </div>
                        <div class="cell__tb">
                            <div style="min-width: 80px"></div>
                        </div>
                        <div class="cell__tb">
                            <div style="max-width: 320px">{{ mediumItem.partner?.name || '' }}</div>
                        </div>
                        <div class="cell__tb">
                            <div style="max-width: 320px">{{ mediumItem.tool?.tool || '' }}</div>
                        </div>
                    </div>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
import { campaignMasterOrderScopesWithPartner } from '@/views/pages/campaign/view/index.js';

export default {
    name: 'TableTools',
    props: {
        dataTools: {
            type: Array,
            default: () => []
        },
        dataOrderScopes: {
            type: Array,
            default: () => []
        },
        masterOrderScope: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            listToolPartner: []
        };
    },

    methods: {},

    watch: {
        dataTools: {
            handler: function (newTool) {
                this.listToolPartner = campaignMasterOrderScopesWithPartner(this.dataOrderScopes, newTool, this.masterOrderScope);
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss" scoped></style>
